import { Link } from '@tanstack/react-router'
import {
  SidebarMenuButton,
  SidebarMenuItem,
} from 'designSystem/components/Sidebar'
import type { NavItemConfig } from 'features/navbar/navConfig'
import React from 'react'

interface EmbeddedSidebarNavItemProps {
  config: NavItemConfig
  siteID: string | undefined
  orgID: string | undefined
  onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

export const EmbeddedSidebarNavItem: React.FC<EmbeddedSidebarNavItemProps> = ({
  config,
  siteID,
  orgID,
  onClick,
}) => {
  const Icon = config.icon
  const params = config.params?.(siteID ?? '', orgID) ?? undefined
  const search = config.search?.(siteID ?? '', orgID) ?? undefined

  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild variant='embedded' tooltip={config.label}>
        <Link to={config.to} params={params} search={search} onClick={onClick}>
          <Icon />
          <span>{config.label}</span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  )
}
